// MVT 相关处理器
import MvtFlightUpdateHandler from "./mvt/MvtFlightUpdateHandler";
import MvtFlightLinker from "./mvt/MvtFlightLinker";
import MvtParseFailedViewer from "./mvt/MvtParseFailedViewer";

// 合同相关处理器
import ContractExpiryWarningViewer from "./contract/ContractExpiryWarningViewer";

// 结算相关处理器
import SettlementInvoiceReview from "./settlement/SettlementInvoiceReview";

// 通用处理器
import ReadOnlyActionDetailViewer from "./common/ReadOnlyActionDetailViewer";
import OperationListReview from "./common/OperationListReview";

// 新增：组件注册表
const customHandlers = {
    settlement_review: SettlementInvoiceReview,
    // 未来可以扩展其他 display_mode
};

/**
 * V6.0 - 遵循前端重构计划的路由逻辑
 * @param {Object} actionItem - Action Item 数据
 * @returns {React.Component}
 */
export const getActionHandlerComponent = (actionItem) => {
    if (!actionItem) {
        console.warn("getActionHandlerComponent: actionItem is null or undefined");
        return null;
    }

    const { status, suggested_payload } = actionItem;

    // 1. 是已完成状态吗? -> 显示只读视图
    if (status === "COMPLETED" || status === "REJECTED" || status === "ARCHIVED") {
        return ReadOnlyActionDetailViewer;
    }

    const displayMode = suggested_payload?.user_interaction?.display_mode;

    // 2. payload 中有 display_mode 吗?
    if (displayMode) {
        // 3. 有注册该 mode 的组件吗?
        const HandlerComponent = customHandlers[displayMode];
        if (HandlerComponent) {
            // -> 使用定制化组件
            return HandlerComponent;
        }
        console.warn(`No custom handler registered for display_mode: "${displayMode}". Falling back to default.`);
    }

    // 4. 回退到默认组件
    return OperationListReview;
};

export { MvtFlightUpdateHandler, MvtFlightLinker, MvtParseFailedViewer, ContractExpiryWarningViewer, SettlementInvoiceReview, ReadOnlyActionDetailViewer, OperationListReview };
